import * as React from "react";
const Webinar = (props) => (
  <svg
    enableBackground="new 0 0 32 32"
    viewBox="0 0 32 32"
    height={32}
    width={32}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill={props.fill}
  >
    <g id="Grid" display="none" />
    <g id="online_education" />
    <g id="online_video" />
    <g id="account" />
    <g id="online_banking" />
    <g id="online_shop" />
    <g id="webinar">
      <path d="m24.265 3.158c-3.167 0-5.735 2.568-5.735 5.735s2.568 5.735 5.735 5.735 5.735-2.568 5.735-5.735-2.568-5.735-5.735-5.735zm1.803 6.405-1.886 1.333c-.543.383-1.292-.005-1.292-.669v-2.666c0-.664.749-1.053 1.292-.669l1.886 1.333c.462.326.462 1.011 0 1.338z" />
      <path d="m19.516 27.941h-2.758v-1.971h-5.981v1.972h-2.758c-.497 0-.9.403-.9.9s.403.9.9.9h11.497c.497 0 .9-.403.9-.9s-.403-.901-.9-.901z" />
      <path d="m24.265 16.428c-4.155 0-7.535-3.38-7.535-7.535 0-.565.068-1.114.186-1.644h-12.396c-1.39.001-2.52 1.131-2.52 2.521v11.88c0 1.39 1.13 2.52 2.52 2.52h18.5c1.39 0 2.52-1.13 2.52-2.52v-5.338c-.415.071-.839.116-1.275.116zm-6.166 3.686c-.159.284-.459.46-.785.46h-7.059c-.326 0-.626-.176-.786-.46-.159-.285-.152-.633.019-.911.488-.794 1.37-1.401 2.433-1.734-.79-.577-1.31-1.504-1.31-2.558 0-1.753 1.421-3.173 3.173-3.173s3.173 1.421 3.173 3.173c0 1.054-.519 1.98-1.31 2.558 1.064.333 1.946.94 2.433 1.734.171.279.178.627.019.911z" />
    </g>
    <g id="at" />
    <g id="email" />
    <g id="chat_bubble" />
    <g id="mobile_payment" />
    <g id="ebook" />
    <g id="browser" />
    <g id="social_media" />
    <g id="online_transfer" />
    <g id="online" />
    <g id="gps" />
    <g id="server" />
    <g id="cloud" />
    <g id="download" />
    <g id="upload" />
    <g id="smart_tv" />
    <g id="vision" />
    <g id="share" />
    <g id="download_cloud" />
    <g id="upload_cloud" />
  </svg>
);
export default Webinar;
